import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid, Button } from "@material-ui/core/";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { isObjectEmpty } from "../../../utils/general";
import { clearLoginData, isLoggedInUpdate } from "../../../reduxSlices/loginSlice";
import {
  getSelectClassCourseDataFromAPI,
  clearErrorStatusCode,
  clearErrorMessage,
} from "../../../reduxSlices/selectClassSlice";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from '../../../utils/localize';
import { getApplicantStatus } from "../../../reduxSlices/applicationSlice";

const useStyle = makeStyles((theme) => ({
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
}));

const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [displayMessage,setDisplayMessage]=useState('')
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });

  const classCourseDataFromAPI = useSelector(
    (state) => state.selectClassData.classCourseDataFromAPI
  );

  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus
  );

  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage
  );

  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus
  );

//current language
 const language =useSelector(state=> state.language.language);
 //set the current language to localize string
 localizedStrings.setLanguage(language)
 useEffect(()=>{
   localizedStrings.setLanguage(language)
 },[language])

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };

    
  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId"))
    );
  }, [dispatch]);

  useEffect(() => {
    if (
      classCourseDataFromAPI.length === 0 &&
      applicantStatus.ses_applicantstatus !== undefined
    ) {
      dispatch(
        getSelectClassCourseDataFromAPI(
          applicantStatus.ses_applicantstatus.ses_studentid
        )
      );
    }
    dispatch(clearErrorMessage());
  }, [dispatch, applicantStatus]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleSnackbarClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  useEffect(() => {
     if (error.message === 'Invalid token') {
      setDisplayMessage(localizedStrings.general.invalidToken);
    }
    else if (error.message === 'Something Went Wrong') {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    }
    else if (error.message === 'Error No class Data Found') {
      setDisplayMessage(localizedStrings.general.errornoclassdata);
    }
    else{
      setDisplayMessage(error.message);
    }
  }, [error]);

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleSnackbarClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid className={classes.classConatiner}>
        <Typography component="div" className={classes.classFont}>
        {localizedStrings.courseCataLog.heading}
        </Typography>
       
      </Grid>
    </Aux>
  );
};

export default withRouter(TopItems);
